<template>
  <v-container class="fill-height d-flex align-center justify-center">
    <v-card class="pa-6" max-width="500px" width="100%" elevation="8">
      <div class="text-center mb-6">
        <v-icon size="64" color="primary" class="mb-4">mdi-email-check</v-icon>
        <v-card-title class="text-h4 pa-0 mb-2">Verify Your Email</v-card-title>
        <v-card-subtitle class="text-body-1"
          >We've sent a 6-digit code to your email</v-card-subtitle
        >
      </div>
      <v-card-text class="pa-0">
        <ConfirmRegisterForm />
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script setup lang="ts">
import ConfirmRegisterForm from "@/components/Auth/ConfirmRegisterForm.vue";
</script>

<style scoped>
.fill-height {
  min-height: 100vh;
}
</style>
